import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { getSlackWorkspacesQueryKey } from 'hooks/queries/notifications/useGetSlackWorkspaces';

import { getSlackRedirectUri } from './_utils/getSlackRedirectUri';

type UseCompleteSlackWorkspacesInstallMutationArgs = {
  accessCode: string;
  id: string;
  state?: string;
};

export const useCompleteSlackWorkspacesInstallMutation = (
  onSuccess?: () => void
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      accessCode,
      id,
      state,
    }: UseCompleteSlackWorkspacesInstallMutationArgs) => {
      return apiClient.notifications.completeSlackWorkspacesInstall({
        id,
        accessCode,
        redirectUri: getSlackRedirectUri(),
        state,
      });
    },
    onSuccess: () => {
      queryClient
        .invalidateQueries({ queryKey: getSlackWorkspacesQueryKey() })
        .then(() => {
          notify.success('Slack workspace connected successfully');
          onSuccess?.();
        });
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
